import {clsx} from 'clsx';
import {isContainerQueryAvailable} from '../lib/container-query-with-fallback';
import styles from './media-user-register-link.module.css';

export function MediaUserRegisterLink({...props}) {
  return (
    <div className={styles.container} {...props}>
      <a
        href='/main/registmedia/form'
        className={clsx(
          styles.link,
          isContainerQueryAvailable() ? styles.linkCQ : styles.linkFallback,
        )}
        target='_blank'
      >
        メディアユーザー新規登録
      </a>
      <span
        className={clsx(
          styles.text,
          isContainerQueryAvailable() ? styles.textCQ : styles.textFallback,
        )}
      >
        無料
      </span>
    </div>
  );
}
